import { API } from '../helpers/fetcher'

export const trustlyAuthentication = async params =>
    API.post('v1/transaction/trustly/authenticate', params)